import { render, staticRenderFns } from "./industryAgriculture.vue?vue&type=template&id=2b498c76&scoped=true&"
import script from "./industryAgriculture.vue?vue&type=script&lang=js&"
export * from "./industryAgriculture.vue?vue&type=script&lang=js&"
import style0 from "./industryAgriculture.vue?vue&type=style&index=0&id=2b498c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b498c76",
  null
  
)

export default component.exports